import { type ReactNode } from 'react'
import { cn } from '~/lib/utils'

export type RadioGroupGridProps = {
  children: ReactNode
  className?: string
}

export const RadioGroupGrid = ({ children, className }: RadioGroupGridProps) => {
  return (
    <div
      className={cn(
        // Row alignment now comes from the field groups themselves (they span two of this grid's
        // rows via `subgrid`), so no legend height is reserved here.
        'grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-3 lg:gap-6 items-stretch',
        className
      )}
    >
      {children}
    </div>
  )
}
